module.exports = __webpack_public_path__ + "img/consulting.835cf721.svg";